import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { colors } from '../Colors';
import Navigation from '../components/Navigation';
import Footer from '../components/layout/Footer';

function Homepage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);


  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: colors.background.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ fontSize: '1.2rem', color: colors.text.secondary }}>
          Chargement...
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: colors.background.main }}>
      <Navigation />
      <main style={{ paddingTop: '0', paddingBottom: '80px' }}>
        {/* Hero Section - Full Width Two Columns */}
        <div style={{ 
          width: '100%',
          marginBottom: '80px',
          padding: '60px 0',
          background: `linear-gradient(135deg, ${colors.primary.dark} 0%, ${colors.primary.main} 30%, ${colors.secondary.dark} 70%, ${colors.secondary.main} 100%)`,
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Background Elements */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '300px',
            height: '300px',
            background: `radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%)`,
            borderRadius: '50%',
            animation: 'pulse 4s ease-in-out infinite'
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-40px',
            left: '-40px',
            width: '250px',
            height: '250px',
            background: `radial-gradient(circle, rgba(255, 255, 255, 0.12) 0%, transparent 70%)`,
            borderRadius: '50%',
            animation: 'pulse 5s ease-in-out infinite'
          }}></div>
          
          {/* Grid Pattern Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `
              linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px',
            pointerEvents: 'none'
          }}></div>

          <div style={{ 
            position: 'relative', 
            zIndex: 2,
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 20px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '60px',
            alignItems: 'center'
          }}>
            {/* Left Column - Text Content */}
            <div style={{ textAlign: 'left', order: 1 }}>
              <h1 style={{ 
                fontSize: '4rem', 
                fontWeight: '900', 
                marginBottom: '20px', 
                background: `linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 50%, #E1E8ED 100%)`, 
                WebkitBackgroundClip: 'text', 
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                lineHeight: '1.1',
                letterSpacing: '-2px',
                textShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}>
                Torah IA
              </h1>
              <p style={{ 
                fontSize: '1.8rem', 
                color: '#FFFFFF', 
                marginBottom: '15px',
                lineHeight: '1.5',
                fontWeight: '600',
                textShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}>
                Création de contenu éducatif pour enfants
              </p>
              <p style={{ 
                fontSize: '1.3rem', 
                color: 'rgba(255, 255, 255, 0.9)', 
                marginBottom: '30px',
                lineHeight: '1.6',
                fontWeight: '400',
                textShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }}>
                Respectueux de la tradition religieuse
              </p>
              
              {/* Feature Pills */}
              <div style={{
                display: 'flex',
                gap: '12px',
                flexWrap: 'wrap',
                marginTop: '30px'
              }}>
                <div style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  ✨ Contenu Personnalisé
                </div>
                <div style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  🤖 Intelligence Artificielle
                </div>
                <div style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  🕎 Respect des Traditions
                </div>
              </div>
            </div>

            {/* Right Column - Visual Element */}
            <div style={{ 
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              order: 2
            }}>
              <div style={{ 
                fontSize: '12rem', 
                filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.2))',
                animation: 'float 3s ease-in-out infinite',
                opacity: 0.95
              }}>
                📖
              </div>
              {/* Decorative circles around icon */}
              <div style={{
                position: 'absolute',
                top: '20%',
                right: '10%',
                width: '80px',
                height: '80px',
                background: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '50%',
                animation: 'pulse 3s ease-in-out infinite'
              }}></div>
              <div style={{
                position: 'absolute',
                bottom: '15%',
                left: '5%',
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.12)',
                borderRadius: '50%',
                animation: 'pulse 4s ease-in-out infinite'
              }}></div>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>

          {/* Mission Section */}
          <div style={{ 
            background: `linear-gradient(135deg, ${colors.background.secondary} 0%, ${colors.background.accent} 100%)`,
            borderRadius: '25px',
            padding: '60px 40px',
            marginBottom: '60px',
            boxShadow: '0 15px 40px rgba(0,0,0,0.12)',
            border: `1px solid ${colors.border.light}`
          }}>
            <h2 style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: colors.text.primary,
              textAlign: 'center',
              background: `linear-gradient(135deg, ${colors.text.primary} 0%, ${colors.primary.dark} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Notre Mission
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: colors.text.secondary,
              textAlign: 'center',
              marginBottom: '50px',
              maxWidth: '700px',
              margin: '0 auto 50px auto'
            }}>
              Nous combinons innovation technologique et respect des traditions pour créer 
              une expérience éducative unique
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '35px',
              marginTop: '40px'
            }}>
              <div style={{ 
                textAlign: 'center',
                background: colors.background.secondary,
                padding: '35px 25px',
                borderRadius: '20px',
                boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                border: `1px solid ${colors.border.light}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.08)';
              }}
              >
                <div style={{ 
                  fontSize: '5rem', 
                  marginBottom: '25px',
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))'
                }}>📚</div>
                <h3 style={{
                  fontSize: '1.6rem',
                  fontWeight: '700',
                  marginBottom: '18px',
                  color: colors.text.primary
                }}>
                  Contenu Éducatif
                </h3>
                <p style={{
                  fontSize: '1.05rem',
                  color: colors.text.secondary,
                  lineHeight: '1.7'
                }}>
                  Nous créons du contenu éducatif de qualité adapté aux enfants, 
                  conçu pour enrichir leur apprentissage tout en respectant les valeurs religieuses.
                </p>
              </div>
              
              <div style={{ 
                textAlign: 'center',
                background: colors.background.secondary,
                padding: '35px 25px',
                borderRadius: '20px',
                boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                border: `1px solid ${colors.border.light}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.08)';
              }}
              >
                <div style={{ 
                  fontSize: '5rem', 
                  marginBottom: '25px',
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))'
                }}>🕎</div>
                <h3 style={{
                  fontSize: '1.6rem',
                  fontWeight: '700',
                  marginBottom: '18px',
                  color: colors.text.primary
                }}>
                  Respect de la Tradition
                </h3>
                <p style={{
                  fontSize: '1.05rem',
                  color: colors.text.secondary,
                  lineHeight: '1.7'
                }}>
                  Tous nos contenus sont créés dans le respect des traditions religieuses, 
                  garantissant une approche authentique et appropriée pour les enfants.
                </p>
              </div>
              
              <div style={{ 
                textAlign: 'center',
                background: colors.background.secondary,
                padding: '35px 25px',
                borderRadius: '20px',
                boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                border: `1px solid ${colors.border.light}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.08)';
              }}
              >
                <div style={{ 
                  fontSize: '5rem', 
                  marginBottom: '25px',
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))'
                }}>🤖</div>
                <h3 style={{
                  fontSize: '1.6rem',
                  fontWeight: '700',
                  marginBottom: '18px',
                  color: colors.text.primary
                }}>
                  Technologie IA
                </h3>
                <p style={{
                  fontSize: '1.05rem',
                  color: colors.text.secondary,
                  lineHeight: '1.7'
                }}>
                  Nous utilisons l'intelligence artificielle pour créer des contenus innovants 
                  et engageants qui captivent l'attention des enfants.
                </p>
              </div>
            </div>
          </div>

          {/* What We Do Section */}
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              color: colors.text.primary,
              textAlign: 'center',
              background: `linear-gradient(135deg, ${colors.text.primary} 0%, ${colors.primary.dark} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Ce Que Nous Faisons
            </h2>
            <div style={{
              background: `linear-gradient(135deg, ${colors.background.secondary} 0%, ${colors.background.accent} 100%)`,
              borderRadius: '25px',
              padding: '50px 45px',
              boxShadow: '0 15px 40px rgba(0,0,0,0.12)',
              border: `1px solid ${colors.border.light}`
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                maxWidth: '950px',
                margin: '0 auto'
              }}>
                <p style={{
                  fontSize: '1.25rem',
                  color: colors.text.primary,
                  lineHeight: '1.9',
                  textAlign: 'center',
                  fontWeight: '400'
                }}>
                  <strong style={{ color: colors.primary.dark }}>Torah IA</strong> est une plateforme dédiée à la création de contenu éducatif pour enfants 
                  qui respecte et honore les traditions religieuses. Notre équipe utilise des technologies 
                  d'intelligence artificielle avancées pour développer des séances éducatives, des activités 
                  pratiques, et des ressources multimédias qui permettent aux enfants d'apprendre tout en 
                  restant fidèles à leurs valeurs religieuses.
                </p>
                <div style={{
                  width: '80px',
                  height: '3px',
                  background: colors.gradients.primary,
                  margin: '10px auto',
                  borderRadius: '2px'
                }}></div>
                <p style={{
                  fontSize: '1.25rem',
                  color: colors.text.primary,
                  lineHeight: '1.9',
                  textAlign: 'center',
                  fontWeight: '400'
                }}>
                  Que ce soit pour créer des leçons interactives, des quiz éducatifs, ou des contenus visuels 
                  et audio, notre plateforme offre aux éducateurs et aux parents les outils nécessaires pour 
                  offrir une expérience d'apprentissage <strong style={{ color: colors.secondary.main }}>enrichissante et respectueuse</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.6;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.8;
          }
        }
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  );
}

export default Homepage;
